import { H4 } from "@/lib/styles";
import { smallLabelTypographicStyle } from "@/lib/styles/helpers";
import styled, { css } from "styled-components";
import { CardContainer, ImageContainer } from "../styles";

export const CardContainerContest = styled(CardContainer)`
  background-color: ${({theme})=> theme.colors.white};
`;

export const ImageContainerContest = styled(ImageContainer)`
  background-color: lightgray;
  margin-bottom: 24px;

  // should zoom image only when the title is hovered
  // use flex order to target image as a next sibling of a title

  order: 1;

  img {
    opacity: 0;
    transition: transform 0.1s ease-in, opacity 0.8s ease-in;

    ${({ $isLoaded }) =>
      $isLoaded &&
      css`
        opacity: 1;
      `}
  }
`;

export const Title = styled(H4)`
  order: 2;
  text-decoration: none;
  color: inherit;
  &:hover {
    & ~ ${ImageContainerContest} {
      img {
        transform: scale(1.1);
      }
    }
    color: ${({ theme }) => theme.colors.darkMiddle};
  }
`;
export const CardInfo = styled.div`
  order: 3;
`;
export const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 8px;
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const Label = styled.p`
  ${smallLabelTypographicStyle}
  color: ${({ theme }) => theme.colors.darkMiddle};
  text-transform: uppercase;
`;
export const EndsOn = styled.p`
  ${smallLabelTypographicStyle}
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black};
`;

export const Prize = styled.a`
  ${smallLabelTypographicStyle}
  font-weight: 400;
  text-transform: uppercase;
`;

export const StatusLabel = styled.div<{ $isActive?: boolean }>`
  ${smallLabelTypographicStyle}
  text-transform: uppercase;
  color: ${({ $isActive, theme }) =>
    $isActive ? theme.colors.greenEco : theme.colors.red};
`;
